import React, {useState} from "react"
import styled from "styled-components"
import {
  Link as LinkScroll,
  animateScroll as scroll,
} from "react-scroll"

//Responsive
import { colors, anims } from "../../../utils/theme"
import FormDudas from "../../../components/temario/FormDudas"
import Modal from "react-bootstrap/Modal"

const Nav = styled.nav`
  & ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    & li {
      padding: 0;
      margin-left: 2rem;
      & a {
        color: white !important;
        font-size: 0.9rem;
        cursor: pointer;
        &.current {
        }
      }
      & .asesory {
        border: none;
        padding: 0.5rem 1rem;
        color: ${colors.pColor};
        font-size: 0.9rem;
        ${anims.transition};
        font-weight: 700;
        text-decoration: none;
        position: relative;
        z-index: 1;
        background: transparent;
        outline: 0;
        &::before {
          content: "";
          width: 100%;
          height: 100%;
          background: ${colors.sColor};
          transform: skew(-7deg);
          position: absolute;
          left: 0;
          top: 0;
          z-index: -1;
          ${anims.transition};
        }
        &::after {
          content: "";
          width: 100%;
          height: 100%;
          border: 2px solid white;
          transform: skew(-7deg);
          position: absolute;
          left: 4px;
          top: 4px;
          z-index: -2;
          box-shadow: 0 0 20px ${colors.pColor};
          ${anims.transition};
        }
        &:hover {
          color: ${colors.pColor} !important;
          &::before {
          }
          &::after {
            left: 7px;
            top: 7px;
          }
        }
      }
    }
  }
`

const Navigation = () => {
  const [modalForm, setModalForm] = useState(false)
  return (
    <>
      <Nav>
        <ul>
          <li>
            <LinkScroll onClick={() => scroll.scrollTo(0)}>Inicio</LinkScroll>
          </li>
          <li>
            <LinkScroll to="reto" offset={-100} smooth={true} duration={1600}>
              El Reto
            </LinkScroll>
          </li>
          <li>
            <LinkScroll to="premios" offset={-100} smooth={true} duration={1600}>
              Premios
            </LinkScroll>
          </li>
          <li>
            <button className="asesory" onClick={ e=>{ setModalForm(true)}}>Regístrate</button>
          </li>
        </ul>
      </Nav>
      <Modal
        show={modalForm}
        onHide={() => setModalForm(false)}
        aria-labelledby="example-modal-sizes-title-sm"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <FormDudas />
        </Modal.Body>
      </Modal>
    </>
  )
}

export default Navigation
